export class HistoryFormatValueConverter {
	toView(value) {
		if (value.historyTypeId === 1)
			return `<span class="font-weight-bold">${value.appUserId} </span> Created Item.`; 
		else
			return `<span class="font-weight-bold">${value.appUserId} </span> Set ${value.columnName} to: ${value.newValue} `;
	}
}